import { Action, createReducer, on } from "@ngrx/store";
import * as fromLanguages from "../actions/languages.action";
import { Language } from "cli-types";

export interface LanguagesState {
    entities: Map<number, Language>;
    loaded: boolean;
    loading: boolean;
}

export const initialState: LanguagesState = {
    entities: new Map<number, Language>(),
    loaded: false,
    loading: false
};

const languageReducer = createReducer(
    initialState,
    on(fromLanguages.loadLanguages, state => ({ ...state, loading: true })),
    on(fromLanguages.loadLanguagesFail, (state, { payload }) => ({
        ...state,
        loaded: false,
        loading: false
    })),
    on(fromLanguages.loadLanguagesSuccess, (state, { payload }) => {
        const activeLanguages = payload;

        // TODO MRK : Do we really want to make this additive?
        const entities = new Map<number, Language>(state.entities.entries());
        activeLanguages.forEach(activeLanguage => {
            entities.set(activeLanguage.languageID, activeLanguage);
        });

        return {
            ...state,
            loaded: true,
            loading: false,
            entities: entities
        };
    })
);

// exporting the reducer so it can be added to the index file
export function reducer(state: LanguagesState | undefined, action: Action) {
    return languageReducer(state, action);
}

export const getLanguagesEntities = (state: LanguagesState) => state.entities;
export const getLanguagesLoading = (state: LanguagesState) => state.loading;
export const getLanguagesLoaded = (state: LanguagesState) => state.loaded;
